export const MODULE_TYPE_SZAFA = 'szafa'
export const MODULE_TYPE_GARDEROB_L_LEFT = 'garderobLLeft'
export const MODULE_TYPE_GARDEROB_L_RIGHT = 'garderobLRight'
export const MODULE_TYPE_GARDEROB_U = 'garderobU'

export const GLOBAL_MODULE_TYPE_SZAFY = 'szafy'
export const GLOBAL_MODULE_TYPE_GARDEROBY = 'garderoby'

export function globalType (currentType) {
  return currentType === MODULE_TYPE_SZAFA ? GLOBAL_MODULE_TYPE_SZAFY : GLOBAL_MODULE_TYPE_GARDEROBY
}



// WEBPACK FOOTER //
// ./resources/js/resource/ModuleTypes.js